import React from "react";

function Clock_Face() {
  return (
    <div>
      <h1>Clock_Face Component</h1>
      <p>This is the Clock Face tutorial page content.</p>
    </div>
  );
}

export default Clock_Face;
